import { Grid } from "@chakra-ui/react";

import CompaniesViewList from "./list";
import CompaniesView from "./view";

const ViewListTools = () => {
  return (
    <Grid
      templateColumns={{ base: "1fr", lg: "auto auto" }}
      alignItems={"center"}
      columnGap={"20px"}
      rowGap={"20px"}
      w={"100%"}
      mb={"12px"}
      px={"20px"}
    >
      <CompaniesView />
      <CompaniesViewList />
    </Grid>
  );
};

export default ViewListTools;
